import {ActivityDisplayState} from './activity-display.state';

export const activityDisplayInitialState: ActivityDisplayState = {
  isVisible: false, // TODO: Sichtbarkeit über den Store steuern und nicht über den Service
  isOpen: true,
};
